function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}, /*#__PURE__*/React.createElement("path", {
  d: "M52.07 8.23s.515.466.676.774c.162.308.254.996.254.996L28.576 21.696z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.5 20.489a23.189 5.153 0 0023.19 5.153 23.189 5.153 0 0023.189-5.153 23.189 5.153 0 00-23.19-5.153 23.189 5.153 0 00-23.188 5.153z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.879 20.489v28.857c0 2.846-10.382 5.153-23.189 5.153S3.501 52.192 3.501 49.346V20.489"
})), /*#__PURE__*/React.createElement("path", {
  d: "M49.879 27.703l-7.214 17.521-8.245-13.398-7.73 14.944-7.73-14.944-8.245 13.398-7.214-17.521M42.479 24.1V53M10.879 24.1V53M26.679 25.3v28.9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45 1s.626.3.869.55c.243.249.527.883.527.883L26.315 20.6v0z",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}));

var SvgDrums = function SvgDrums(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDrums, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Drums.19097ebc.svg";
export { ForwardRef as ReactComponent };